import {supabase} from './supabaseClient';

export async function loadCompanyDns(companyId) {
  const {data}=await supabase.auth.getSession();
  if(!data?.session?.access_token)throw new Error('Please sign in again.');
  const response=await fetch(`/api/company-dns?company_id=${encodeURIComponent(companyId)}`,{headers:{Authorization:`Bearer ${data.session.access_token}`},cache:'no-store'});
  const result=await response.json().catch(()=>null);
  if(!response.ok)throw new Error(result?.error||'Could not prepare the company DNS checklist.');
  if(result?.company_id!==companyId || !Array.isArray(result.websites) || !Array.isArray(result.warnings))throw new Error('Could not confirm the company DNS checklist.');
  return result;
}
function recordLines(record,domain) {
  let name=record.name;
  if(domain) {
    if(name==='@')name=domain;
    else if(name.endsWith('.'))name=name.slice(0,-1);
    else if(name!==domain && !name.endsWith(`.${domain}`))name=`${name}.${domain}`;
  }
  return [`Type: ${record.type}`,`Name / full hostname: ${name}`,`Value: ${record.value}`,...(record.priority!==undefined?[`Priority: ${record.priority}`]:[]),''];
}
export function companyDnsChecklist(companyName,data) {
  const lines=[`${companyName} — Payroll website and email DNS setup`,'',
    'For the company DNS administrator',
    'Add the following public DNS records in the authoritative DNS service for the company domain.',
    'Keep existing website and mailbox records. Do not replace existing MX, SPF, DKIM or DMARC records blindly.',
    'Names below are full hostnames. If your DNS provider adds the zone automatically, use the relative host portion so the domain is not repeated.',
    'Use the default TTL unless your IT policy requires a different value. Use DNS-only for verification/email CNAME records when applicable.','',
    '1. Payroll website'];
  if(!data.websites.length)lines.push(`Shared employee portal: https://${data.email?.portal_hostname||'salary.trustwork.co.in'}/?mode=employee`,'No custom company website address is registered; no website DNS record is requested.','');
  for(const site of data.websites) {
    lines.push(`Website: https://${site.hostname}`);
    if(!site.dns_records.length)lines.push('DNS records not ready — contact the payroll administrator.','');
    for(const record of site.dns_records)lines.push(...recordLines(record));
  }
  lines.push('2. Company notification email');
  if(data.email) {
    lines.push(`Sender: ${data.email.sender_name} <${data.email.sender_email}>`,`Email sending domain: ${data.email.domain}`,'');
    for(const record of data.email.dns_records)lines.push(...recordLines(record,data.email.domain));
    if(data.email.note)lines.push(data.email.note,'');
  }else lines.push('Company email sender is not configured yet.','');
  if(data.warnings.length)lines.push('Setup items still pending:',...data.warnings.map(warning=>`- ${warning}`),'');
  lines.push('3. After the records are saved',
    'Reply to the payroll administrator confirming the records were added. DNS propagation and certificate verification can take time.',
    'The payroll administrator checks the website connection, activates the address and checks the email sender verification in TrustWork.',
    'No Cloudflare/Resend API key, Supabase configuration, passwords or mailbox access need to be shared with company IT.');
  return lines.join('\n');
}
